'use client';

import { VariantFieldset } from '../product-details';
import { MiniPdpVariantRow } from './mini-pdp-variant-row';
import { type MiniPdpVariantsProps, useMiniPdpVariants } from './model/use-mini-pdp-variants';

export function MiniPdpVariants({ base, tailored }: MiniPdpVariantsProps) {
    const { handleVariantChange, variantGroups } = useMiniPdpVariants({ base, tailored });

    if (!variantGroups.length) return null;

    return (
        <div className="mini-pdp-drawer__variants" data-testid="mini-pdp-variants">
            {variantGroups.map(group => (
                <VariantFieldset key={group.name} legendKey={group.name} legendValue={group.display}>
                    {group.variants.length > 1 && (
                        <MiniPdpVariantRow group={group} onChange={value => handleVariantChange(group.name, value)} />
                    )}
                </VariantFieldset>
            ))}
        </div>
    );
}
